<template>
  <el-breadcrumb class="app-breadcrumb" separator-class="el-icon-arrow-right">
    <transition-group name="breadcrumb" v-if="Object.keys(levelList).length > 0">
      <el-breadcrumb-item
        :key="0"
        v-if="levelList.company.name"
        :to="superRole ? { path: `/company/info/${levelList.company.uid}`} : null"
        >Company: {{ levelList.company.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
      :key="1"
        v-if="levelList.project.name"
        :to="{ path: `/project/${levelList.project.uid}${getRef}` }"
        >Project: {{ levelList.project.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item
      :key="2"
        v-if="levelList.customer.name"
        :to="{
          path: `/customer/view/${levelList.project.uid}/${levelList.customer.uid}`,
        }"
        >Customer: {{ levelList.customer.name }}</el-breadcrumb-item
      >
      <el-breadcrumb-item :key="3" v-if="levelList.bankaccount.name">Bank Account: {{
        levelList.bankaccount.name
      }}</el-breadcrumb-item>
      <el-breadcrumb-item :key="4" v-if="lastname">{{
        lastname
      }}</el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
import { getBreadcrumbs } from "@/api/breadcrumb";
export default {
  props:{
    company:String,
    project:String,
    customer:String,
    bankaccount: String,
    lastname: String
  },
  computed:{
    getRef(){
      return (this.$route.query.ref && this.$route.query.ref === 'customer') ? `?tab=customer` : '';
    },
    superRole(){
      return this.roleAuth([this.role.spadmin])
    }
  },
  data() {
    return {
      levelList: {},
    }
  },
  methods:{
    getBreadcrumbsData(){
      const formData = {}

      if(this.company) formData.company = this.company
      if(this.project) formData.project = this.project
      if(this.customer) formData.customer = this.customer
      if(this.bankaccount) formData.bankaccount = this.bankaccount

      getBreadcrumbs(formData).then(({result, data})=>{
        this.levelList = data
      })
      
    },
    reload(){
      this.getBreadcrumbsData()
    }
  },
  created() {
    this.getBreadcrumbsData()
  }
}
</script>

<style lang="scss" scoped>
.app-breadcrumb.el-breadcrumb {
  display: inline-block;
  font-size: 12px;
  margin-bottom: 10px;

  .no-redirect {
    color: #97a8be;
    cursor: text;
  }
}
</style>
